import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            {/**************Heading ********************/}
            <h2 className="text-center my-4"><i className="fab fa-pagelines"></i>Welcome to Athena Coaching Center</h2>
           
        </div>
    );
};

export default Header;